import { useState } from 'react';
import Button from '../../components/form-control/Button';
import Input from '../../components/form-control/Input';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { createPartner } from '../../api/requests';
import { XMarkIcon } from '@heroicons/react/24/solid';
import { PARTNER_TYPES } from '../../resources/enums';
import { IAddPartnerDTO } from '../../resources/interfaces';
import { MdGroupAdd } from 'react-icons/md';
import SelectDropdown from '../../components/form-control/SelectDropdown';
import { getFormattedPartnerTypeFromKey, showToast } from '../../utils/miscFunctions';
import { GHANA_REGIONS } from '../../resources/constants';
import usePartner from '../../hooks/partnerHook';
import { useQuery } from '@tanstack/react-query';
import useUserAccount from '../../hooks/userAccountHook';

interface CreateTeamProps {
    onProceed: (data: any) => void;
    onClose: () => void;
}
const AddPartner = ({ onProceed, onClose }: CreateTeamProps) => {
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const { getAllSlackWorkspaces } = usePartner();
    const { user } = useUserAccount();

    const { data: workspaces } = useQuery({ queryKey: ['workspaces'], queryFn: getAllSlackWorkspaces });

    const submitHandler = (values: any) => {
        setIsSubmitting(true);
        const payload: IAddPartnerDTO = {
            name: values.name,
            city: values.city,
            region: values.region,
            type: values.type,
            slackWorkspaceId: values.slackWorkspaceId,

        };

        createPartner(payload)
            .then((response: any) => {
                showToast.success(response?.message || 'Partner created successfully');
                onProceed(response);
            })
            .catch((error: any) => {
                showToast.error(error?.description);
            })
            .finally(() => setIsSubmitting(false));
    };

    return (
        <Formik
            initialValues={{
                name: '',
                type: '',
                region: '',
                city: '',
                slackWorkspaceId: ''
            }}
            validateOnChange={false}
            validateOnBlur
            validationSchema={Yup.object().shape({})}
            onSubmit={(values) => {
                submitHandler(values);
            }}>
            {({
                values,
                errors,
                isSubmitting,
                handleSubmit,
                handleChange,
                setFieldValue,
                handleBlur,
                touched
            }) => (
                <form className=" bg-white" onSubmit={handleSubmit}>
                    <div className="bg-primary-main flex justify-between p-5">
                        <div className=" flex justify-between w-full items-center">
                            <div className="flex items-center justify-center gap-5">
                                <div className="flex items-center justify-center bg-white p-2 rounded-full">
                                    <MdGroupAdd className="h-4 w-4" />
                                </div>
                                <h2 className="font-[gilroy-bold] text-lg">Add Group</h2>
                            </div>
                            <XMarkIcon onClick={onClose} width={'18px'} height={'18px'} className="cursor-pointer" />
                        </div>
                    </div>

                    <div className="space-y-5 p-5">
                        <Input
                            label="Partner Name"
                            placeholder="Enter partner name"
                            name="name"
                            value={values.name}
                            type="text"
                            wrapperClasses=""
                            required
                            error={errors.name}
                            onChange={handleChange}
                            onBlur={handleChange}
                        // helperText={errors.name}
                        />

                        <SelectDropdown
                            label="Type"
                            name="type"
                            listSelectedValue={values.type}
                            list={Object.values(PARTNER_TYPES)?.map((partner: any, index: number) => ({
                                name: getFormattedPartnerTypeFromKey(partner),
                                value: partner
                            }))}
                            onChange={(val: string | null) => setFieldValue('type', val)}
                            onBlur={handleBlur}
                            placeholder="Select partner type"
                            required
                        />
                        <SelectDropdown
                            label="Region"
                            name="region"
                            listSelectedValue={values.region}
                            list={GHANA_REGIONS?.map((region: string, id: number) => ({
                                name: (region),
                                value: region
                            }))}
                            onChange={(val: string | null) => setFieldValue('region', val)}
                            onBlur={handleBlur}
                            placeholder="Select team region"
                            required

                        />

                        {
                            values.region &&
                            <Input
                                label="City"
                                placeholder="Enter city"
                                name="city"
                                value={values.city}
                                type="text"
                                wrapperClasses=""
                                required
                                error={errors.city}
                                onChange={handleChange}
                                onBlur={handleChange}
                                helperText={errors.name}
                            />
                        }
                        {user?.isInternalOwner() && (
                            <SelectDropdown
                                name="slackWorkspaceId"
                                label="Slack Workspace"
                                placeholder="Select workspace "
                                listSelectedValue={values.slackWorkspaceId}
                                onChange={(value: any) => {
                                    setFieldValue('slackWorkspaceId', value);
                                }}
                                list={workspaces?.map((workspace: any) => ({
                                    name: workspace?.name,
                                    value: workspace?.id
                                })
                                )}
                            />
                        )}
                    </div>

                    <div className="flex  items-center justify-between p-5">
                        <div className="">
                            <Button
                                className="min-w-[120px] px-4 py-4 h-[45px] rounded border border-primary-border hover:bg-primary-main "
                                label="Back"
                                onClick={onClose}
                            />
                        </div>
                        <div className="">
                            <Button
                                label="Save"
                                className="min-w-[120px] h-[45px] hover:bg-primary-border flex items-center justify-center rounded p-4"
                                bgColor="primary"
                                type="submit"
                                loading={isSubmitting}
                                disabled={isSubmitting}
                            />
                        </div>
                    </div>
                </form>
            )}
        </Formik>
    );
};

export default AddPartner;
